<template>
  <div class="container">
    <div class="infoList">
      <InfoItem class="infoItem" :item="tabNames[0]"/>
      <InfoItem class="infoItem" :item="tabNames[1]"/>
    </div>
    <div class="infoList">
      <InfoItem class="infoItem" :item="tabNames[2]"/>
      <div class="honor">
        <div class="title">
          <div class="left">
            <svg t="1663320740080" class="icon"
                 viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="2747"
                 width="25" height="25">
              <path d="M975.7 188.4H868.9v-68c0-26.7-21.7-48.3-48.3-48.3H203.4c-26.7 0-48.3 21.7-48.3 48.3v68H48.3C21.7 188.4 0 210.1 0 236.8V328c0 48.4 17.9 94.6 50.5 130.2 33.4 36.5 78.3 57.3 126.4 58.8 1.9 0.1 3.7 0.1 5.6 0.1 5.2 0 10.5-0.2 15.7-0.7 14.7 27.7 32.9 53.6 54.4 77.1 47.7 52.1 107.8 88 173.8 104.6V893c0 1.3 0.1 2.6 0.3 3.9h-89.1c-15.2 0-27.5 12.3-27.5 27.5s12.3 27.5 27.5 27.5h348.9c15.2 0 27.5-12.3 27.5-27.5s-12.3-27.5-27.5-27.5h-89.1c0.2-1.3 0.3-2.5 0.3-3.9V698.4c14.1-3.5 28.1-7.8 41.8-13.1 44.4-17 84.4-42.3 118.9-75.2 28.7-27.3 52.2-58.7 70.3-93.5 2.4 0.2 4.8 0.3 7.3 0.4 1.9 0.1 3.8 0.1 5.7 0.1 47.7 0 92.6-18.2 127-51.5 35.8-34.7 55.4-81.2 55.4-131.1v-97.7c-0.1-26.7-21.8-48.4-48.4-48.4zM54.9 328v-84.7H155v99c0 41.1 6.7 81.5 19.6 119.6-66.3-4.1-119.7-63.3-119.7-133.9zM543 897h-62c0.2-1.3 0.3-2.5 0.3-3.9V707.4c4.5 0.4 9 0.7 13.5 0.9 5.8 0.3 11.6 0.4 17.4 0.4 10.2 0 20.4-0.4 30.5-1.3V893c0 1.4 0.1 2.7 0.3 4z m177.4-326.6c-29.2 27.9-63.1 49.3-100.6 63.6-16.9 6.5-34.2 11.3-51.8 14.6-1.8 0.1-3.5 0.4-5.2 0.9-21.4 3.6-43.3 5-65.5 3.9-12.5-0.6-24.8-2-37-4.1-0.9-0.2-1.9-0.4-2.9-0.5-62.5-11.7-119.8-43.6-164.4-92.3-53.5-58.5-83-134.6-83-214.2V127h604v224.6c0 42.1-8.5 82.8-25.2 121-16.1 37-39.1 69.8-68.4 97.8z m248.7-235.9c0 34.8-13.8 67.4-38.8 91.7-21.6 20.9-49.1 33.3-78.6 35.6 11.5-35.4 17.3-72.3 17.3-110.2V243.4h100.1v91.1z"
                    p-id="2748"/>
            </svg>
            <span class="text">荣誉资质</span>
          </div>
          <div class="right" @click="loadMoreHonor">
            更多
            <svg t="1663287428679" class="icon"
                 viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="1498"
                 width="25" height="25">
              <path d="M436.053333 308.053333a32 32 0 0 1 45.226667 0L685.226667 512l-203.946667 203.946667a32 32 0 1 1-45.226667-45.226667L594.773333 512l-158.72-158.72a32 32 0 0 1 0-45.226667z"
                    p-id="1499"/>
            </svg>
          </div>
        </div>
        <div class="carousel">
          <el-carousel :interval="2000" type="card" height="200px">
            <el-carousel-item v-for="(imgData, key) in honorImgData" :key="key">
              <el-image :src="imgData.pic" @click="loadHonorDetail(imgData)"/>
              <span class="text">{{ imgData.label }}</span>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // components
  import InfoItem from './components/infoItem'
  // config
  import { mocHonorImgData } from '@/mocData/indexAll.js'
  export default {
    name: "advertisement",
    components: { InfoItem },
    data() {
      return {
        tabNames: [
          {
            label: '主要业务',
            name: 'service',
            route: '/',
            moreUrl: 'http://csyjs.bgrimm.com/zyyw/index.htm',
            listContents: [{
              title: '铜精矿全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4129.htm',
              route: '/'
            }, {
              title: '铅精矿全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4131.htm',
              route: '/'
            }, {
              title: '锌精矿全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4132.htm',
              route: '/'
            }, {
              title: '钼精矿全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4290.htm',
              route: '/'
            }, {
              title: '钨矿石、钼矿石全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4293.htm',
              route: '/'
            }, {
              title: '铜铅锌矿石全元素分析',
              url: 'http://csyjs.bgrimm.com/zyyw/4277.htm',
              route: '/'
            }]
          }, {
            label: '新闻资讯',
            name: 'news',
            route: '/',
            moreUrl: 'http://csyjs.bgrimm.com/xwzx/gsdt/index.htm',
            listContents: [{
              title: '公正性和保密性声明',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/f2cc6f3b1ac44ec480b5b70238ee47cb.htm',
              route: '/'
            }, {
              title: '中国矿冶检测机构联盟揭牌成立',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/5384.htm',
              route: '/'
            }, {
              title: '有色金属将迎来电商时代',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/4303.htm',
              route: '/'
            }, {
              title: '中国稀土行业未来发展趋势',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/4305.htm',
              route: '/'
            }, {
              title: '83项有色金属新标准通过审定',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/4304.htm',
              route: '/'
            }, {
              title: '国检总局、标准委发布第25号公告，共47条检测相关标准',
              url: 'http://csyjs.bgrimm.com/xwzx/gsdt/5399.htm',
              route: '/'
            }]
          }, {
            label: '科研项目',
            name: 'research',
            route: '/',
            moreUrl: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/index.htm',
            listContents: [{
              title: '有色金属产品检验鉴定',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/7135fe76ce2c491eb9fbb7f0ce48a635.htm',
              route: '/'
            }, {
              title: '化学分析方法标准制定、修订',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/4337.htm',
              route: '/'
            }, {
              title: '政府委托的质量监督检验与评价',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/4338.htm',
              route: '/'
            }, {
              title: '冶金、地矿、化学实验室三废',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/4343.htm',
              route: '/'
            }, {
              title: '稀有元素标准检测方法研究',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/4342.htm',
              route: '/'
            }, {
              title: '企业委托的仲裁检验、质量评价、委托检验',
              url: 'http://csyjs.bgrimm.com/gjxybzhkycg/kyxm/4338.htm',
              route: '/'
            }]
          }
        ],
        honorImgData: [{
          pic: '',
          label: ''
        }],
        moreHonorUrl: '',
        morHonorRoute: '',
      }
    },
    created() {},
    mounted() {
      this.honorImgData = mocHonorImgData.imgData;
      this.moreHonorUrl = mocHonorImgData.moreUrl;
      this.morHonorRoute = mocHonorImgData.route;
    },
    methods: {
      loadMoreHonor() {
        if(this.morHonorRoute !== '' && this.morHonorRoute !== '/') {
          // 项目中路由跳转
          this.$router.push({ path: this.morHonorRoute });
        } else {
          // 打开新页面
          window.open(this.moreHonorUrl, '_blank');
        }
      },
      loadHonorDetail(data) {
        if(data.route !== '' && data.route !== '/') {
          // 项目中路由跳转
          this.$router.push({ path: data.route });
        } else {
          // 打开新页面
          window.open(data.url, '_blank');
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  path{
    fill: $mainColor;
  }
  .container{
    display: flex;
    flex-direction: column;
    .infoItem{
      width: 48%;
      padding-bottom: 20px;
    }
    .infoList{
      width: 1170px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .honor{
      width: 48%;
      .title{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid $mainColor;
        .left{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;
          font-size: 18px;
          color: $mainColor;
          .text{
            margin: 3px 0 0 10px;
          }
        }
        .right{
          width: 20%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 13px;
          font-size: 14px;
          color: $mainColor;
          &:hover{
            cursor: pointer;
          }
        }
      }
      .carousel{
        >>>.el-carousel{
          margin-top: 20px;
        }
        >>>.el-image{
          height: 200px;
          width: 280px;
        }
        .text{
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/adv/index.vue